/* Elavie timer strip — evergreen countdown (loops forever, comme Uvola). */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }
  function initTimers() {
    var timers = document.querySelectorAll('.timer-strip__clock');
    if (!timers.length) return;
    timers.forEach(function (timer) {
      if (timer.__elTimerInit) return;
      timer.__elTimerInit = true;
      var h = parseInt(timer.dataset.hours, 10) || 0;
      var m = parseInt(timer.dataset.minutes, 10) || 0;
      var total = h * 3600 + m * 60;
      if (total <= 0) return;
      var hoursEl = timer.querySelector('[data-hours]');
      var minutesEl = timer.querySelector('[data-minutes]');
      var secondsEl = timer.querySelector('[data-seconds]');
      if (!hoursEl || !minutesEl || !secondsEl) return;
      var remaining = total;
      function render(s) {
        hoursEl.textContent = pad(Math.floor(s / 3600));
        minutesEl.textContent = pad(Math.floor((s % 3600) / 60));
        secondsEl.textContent = pad(Math.floor(s % 60));
      }
      function tick() { render(remaining); remaining > 0 ? remaining-- : remaining = total; }
      tick();
      setInterval(tick, 1000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTimers);
  else initTimers();
})();
